DJ.addBehavior('cuisine-filter-form', '.cuisine-filter-form', {
  attach: function(context, settings, behavior) {
    once('toggle-open', '.cuisine-form--filters > .form-item').forEach(el => {
      el.addEventListener('click', function(e) {
        const isOpen = el.classList.contains('open');

        document.querySelector('.cuisine-form--filters > .form-item.open')?.classList.remove('open');

        if (isOpen) {
          el.classList.remove('open');
        } else {
          el.classList.add('open');
        }
      });
    });

    document.querySelectorAll('.cuisine-filter-form').forEach(form => {
      const arr = {};

      form.querySelectorAll('input[name^="effets_secondaires"]').forEach(el => {
        arr[el.nextElementSibling.innerHTML] = el.value;
      });

      form.querySelectorAll('input[name^="effets_secondaires"]').forEach(el => {
        if (el.checked) {
          switch (el.nextElementSibling.innerHTML) {
            case 'Diarrhée':
              form.querySelector('input[name="effets_secondaires[' + arr['Constipation'] + ']"]').disabled = el.checked;
              break;
            case 'Constipation':
              form.querySelector('input[name="effets_secondaires[' + arr['Diarrhée'] + ']"]').disabled = el.checked;
              break;
            case 'Altérations du goût : perte de goût':
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût désagréable'] + ']"]').disabled = el.checked;
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût métallique'] + ']"]').disabled = el.checked;
              break;
            case 'Altérations du goût : goût désagréable':
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : perte de goût'] + ']"]').disabled = el.checked || form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût métallique'] + ']"]').checked;
              break;
            case 'Altérations du goût : goût métallique':
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : perte de goût'] + ']"]').disabled = el.checked || form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût désagréable'] + ']"]').checked;
              break;

            default:
              break;
          }
        }

        el.addEventListener('change', function(e) {
          switch (el.nextElementSibling.innerHTML) {
            case 'Diarrhée':
              form.querySelector('input[name="effets_secondaires[' + arr['Constipation'] + ']"]').disabled = el.checked;
              break;
            case 'Constipation':
              form.querySelector('input[name="effets_secondaires[' + arr['Diarrhée'] + ']"]').disabled = el.checked;
              break;
            case 'Altérations du goût : perte de goût':
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût désagréable'] + ']"]').disabled = el.checked;
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût métallique'] + ']"]').disabled = el.checked;
              break;
            case 'Altérations du goût : goût désagréable':
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : perte de goût'] + ']"]').disabled = el.checked || form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût métallique'] + ']"]').checked;
              break;
            case 'Altérations du goût : goût métallique':
              form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : perte de goût'] + ']"]').disabled = el.checked || form.querySelector('input[name="effets_secondaires[' + arr['Altérations du goût : goût désagréable'] + ']"]').checked;
              break;

            default:
              break;
          }
        });
      });

      // Get the current URL
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.get("pour_qui") && urlParams.get("pour_qui") !== '') {
        form.querySelector('[data-drupal-selector="edit-pour-qui"] .fieldset-legend').innerHTML = form.querySelector('input[name="pour_qui"]:checked + .option').innerHTML;
      }

      if (urlParams.get("effets_secondaires") && urlParams.get("effets_secondaires") !== '') {
        form.querySelector('[data-drupal-selector="edit-effets-secondaires"] .fieldset-legend').innerHTML = '<span class="items">' + [...form.querySelectorAll('input[name^="effets_secondaires"]:checked + .option')].map(cb => cb.innerHTML).join(', ') + '</span><span class="count">' + [...form.querySelectorAll('input[name^="effets_secondaires"]:checked + .option')].length + '</span>';
      }

      if (urlParams.get("traitement") && urlParams.get("traitement") !== '') {
        form.querySelector('[data-drupal-selector="edit-traitements"] .fieldset-legend').innerHTML = '<span class="items">' + [...form.querySelectorAll('input[name^="traitements"]:checked + .option')].map(cb => cb.innerHTML).join(', ') + '</span><span class="count">'  + [...form.querySelectorAll('input[name^="traitements"]:checked + .option')].length + '</span>';
      }

      const defaultLegend = {
        pourQui: 'Pour qui ?',
        traitements: 'Pour quel(s) traitement(s) ?',
        effetsSecondaires: 'Pour quel(s) effet(s) secondaire(s) ?',
      };

      form.addEventListener('change', function(e) {
        // Récupérer la valeur du radio sélectionné
        const pourQui = form.querySelector('input[name="pour_qui"]:checked')?.value;

        if (pourQui) {
          form.querySelector('[data-drupal-selector="edit-pour-qui"] .fieldset-legend').innerHTML = form.querySelector('input[name="pour_qui"]:checked + .option').innerHTML;
        } else {
          form.querySelector('[data-drupal-selector="edit-pour-qui"] .fieldset-legend').innerHTML = defaultLegend.pourQui;
        }

        // Récupérer les valeurs des checkboxes cochées
        const traitements = [...form.querySelectorAll('input[name^="traitements"]:checked')].map(cb => cb.value);

        if (traitements.length) {
          form.querySelector('[data-drupal-selector="edit-traitements"] .fieldset-legend').innerHTML = '<span class="items">' + [...form.querySelectorAll('input[name^="traitements"]:checked + .option')].map(cb => cb.innerHTML).join(', ') + '</span><span class="count">'  + [...form.querySelectorAll('input[name^="traitements"]:checked + .option')].length + '</span>';
        } else {
          form.querySelector('[data-drupal-selector="edit-traitements"] .fieldset-legend').innerHTML = defaultLegend.traitements;
        }

        // Récupérer les effets secondaires
        const effetsSecondaires = [...form.querySelectorAll('input[name^="effets_secondaires"]:checked')].map(cb => cb.value);

        if (effetsSecondaires.length) {
          form.querySelector('[data-drupal-selector="edit-effets-secondaires"] .fieldset-legend').innerHTML = '<span class="items">' + [...form.querySelectorAll('input[name^="effets_secondaires"]:checked + .option')].map(cb => cb.innerHTML).join(', ') + '</span><span class="count">' + [...form.querySelectorAll('input[name^="effets_secondaires"]:checked + .option')].length + '</span>';
        } else {
          form.querySelector('[data-drupal-selector="edit-effets-secondaires"] .fieldset-legend').innerHTML = defaultLegend.effetsSecondaires;
        }
      });

      form.addEventListener('reset', function() {
        form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(input => {
          input.removeAttribute('checked');
          input.checked = false;

          // 🔥 Trigger change event
          const event = new Event('change', { bubbles: true });
          input.dispatchEvent(event);
        });
      })
    });
  },

  detach: function(context, settings) {}
});
